import ContactsContainer from "../../components/applications/contacts";

const Contacts = () => {
  return <ContactsContainer />;
};

export default Contacts;
